import { useCallback, useState } from 'react';
import { Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';

interface AttachmentViewerState {
  visible: boolean;
  images: string[];
  index: number;
}

export function useAttachmentViewer() {
  const navigation = useNavigation();

  const [viewer, setViewer] = useState<AttachmentViewerState>({
    visible: false,
    images: [],
    index: 0,
  });

  const openImageViewer = useCallback((images: string[], index: number) => {
    setViewer({ visible: true, images, index });
  }, []);

  const closeImageViewer = useCallback(() => {
    setViewer((prev) => ({ ...prev, visible: false }));
  }, []);

  const openDocument = useCallback((url: string, title: string) => {
    if (Platform.OS === 'web') {
      (globalThis as any).open(url, '_blank');
    } else {
      (navigation as any).navigate('WebView', { url, title });
    }
  }, [navigation]);

  return {
    viewerVisible: viewer.visible,
    viewerImages: viewer.images,
    viewerIndex: viewer.index,
    openImageViewer,
    closeImageViewer,
    openDocument,
  };
}
